// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CvlQ","index":"styles_index__1pxvu"};